import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

export default function MediaKitCarousel({ children, testId }) {
  const ref = useRef(null);
  const scroll = (dir) => ref.current?.scrollBy({ left: dir * 320, behavior: "smooth" });
  const btn = "absolute top-1/2 -translate-y-1/2 z-20 bg-[#FFE500] hover:bg-[#FFE500]/80 text-black rounded-full p-2 md:p-3 transition-all shadow-lg";

  return (
    <div className="relative z-10 px-4 md:px-12">
      <button onClick={() => scroll(-1)} className={`${btn} left-2 md:left-4`} data-testid={`${testId}-prev`}>
        <ChevronLeft className="w-5 h-5 md:w-6 md:h-6" />
      </button>
      <button onClick={() => scroll(1)} className={`${btn} right-2 md:right-4`} data-testid={`${testId}-next`}>
        <ChevronRight className="w-5 h-5 md:w-6 md:h-6" />
      </button>
      <div
        ref={ref}
        className="flex gap-6 overflow-x-auto scrollbar-hide scroll-smooth px-8 md:px-16 pb-4 [&>*:first-child]:ml-auto [&>*:last-child]:mr-auto"
        style={{ scrollbarWidth: "none", msOverflowStyle: "none" }}
        data-testid={testId}
      >
        {children}
      </div>
    </div>
  );
}
